import HamburgerMenu from './HamburgerMenu';
import { ReactComponent as HeaderBrandLogo } from '../logos/Hibbert Inventory Management Logo.svg';
import { useEffect } from 'react';

export default function Header(userData) {

  return (
    <header className="app-header">
      <div className="header-top-row">
        <div className="header-brand">
          <HeaderBrandLogo
            className="header-brand-logo"
            role="img"
            aria-label="Hibbert Inventory Management"
            focusable="false"
          />
        </div>
        <div className="header-top-right">
          <HamburgerMenu />
          <div className="header-welcome">Welcome {userData?.userData ? userData?.userData[0]?.firstName : ""} {userData?.userData ? userData?.userData[0]?.lastName : ""}</div>
        </div>
      </div>
    </header>
  );
}
